var __rspack_ns_object = JSON.parse('{"Measurements":"Mediciones","Studies":"Estudios"}')